// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-SalesChannelPreviewPageComponents-GeneralCollapseContent-css__container--fIJid"};